import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    confirmMessage: {
        paddingBottom: '10px',
    },
    identifier: {
        color: theme.custom.textDarkSecondaryMutedColor,
    },
    description: {
        marginTop: '10px',
        color: theme.custom.textDarkSecondaryMutedColor,
    },
}));

export default useStyles;
